"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadContentType = void 0;
var HeadContentType;
(function (HeadContentType) {
    HeadContentType["SEO"] = "seo";
    HeadContentType["SEO_DEBUG"] = "seo_debug";
    HeadContentType["GENERAL"] = "general";
})(HeadContentType = exports.HeadContentType || (exports.HeadContentType = {}));
//# sourceMappingURL=headContent.js.map